/**
 * Short human-readable format for a time estimate.
 *
 * For smaller values, a nice, rounded value is used as estimates tend to be imprecise.
 *
 * NOTE: Estimates can be produced using a ProgressEstimator / ExecutionPlan on the backend.
 *
 * @param ms - estimate as a number of milliseconds
 * @param short - If true, use an abbreviated format
 *
 * @example
 *   formatEstimateMs(29000) === 'less than 30 seconds'
 *   formatEstimateMs(29000, {short: true}) === '30s'
 */
export default function formatEstimateMs(ms: number, {short = false}: {short?: boolean} = {}): string {
  if (ms < 10e3) {
    return short ? '10s' : 'a few seconds';
  } else if (ms < 30e3) {
    return short ? '30s' : 'less than 30 seconds';
  } else if (ms < 60e3) {
    return short ? '1m' : 'less than a minute';
  } else {
    const minutes = Math.ceil(ms / 60e3);
    return short ? `${minutes}m` : `${minutes} minutes`;
  }
}
